module.exports = __webpack_public_path__ + "static/cart-a4d8d69a0ce73648398984d8599d8dbc.svg";